import { useAxios, useSubjectMember } from '@healthblocks-io/core'
import { useState } from 'react'

import { BadgeService } from '@/modules/shared/services/badgeService'

export function useBadgeCount() {
  const [badgeCount, setBadgeCount] = useState<number>()

  const axios = useAxios()
  const subjectMember = useSubjectMember()

  const updateBadgeCount = async () => {
    try {
      if (!subjectMember?.id) {
        throw new Error('Subject member not found')
      }

      const response = await axios.get<{ count: number }>(`/notification/badgeCount?subjectId=${subjectMember?.id}`)
      const newCount = response.data.count
      setBadgeCount(newCount)

      // Update app badge count
      await BadgeService.setBadgeCount(newCount)
    } catch (error) {
      console.error(error)
    }
  }

  const resetBadgeCount = async () => {
    setBadgeCount(0)
    // Clear app badge when resetting the count
    await BadgeService.clearBadge()
  }

  return { updateBadgeCount, badgeCount, resetBadgeCount }
}
